import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslocoModule } from '@jsverse/transloco';

import { TestEnvironmentComponent } from './test-environment.component';

@NgModule({
  declarations: [TestEnvironmentComponent],
  imports: [
    CommonModule,
    TranslocoModule,
    MatDialogModule,
    MatButtonModule
  ]
})
export class TestEnvironmentModule { }
